import { render, staticRenderFns } from "./MovieBottomButton.vue?vue&type=template&id=6eb67f5c&scoped=true"
import script from "./MovieBottomButton.vue?vue&type=script&lang=js"
export * from "./MovieBottomButton.vue?vue&type=script&lang=js"
import style0 from "./MovieBottomButton.vue?vue&type=style&index=0&id=6eb67f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb67f5c",
  null
  
)

export default component.exports